import Typist from 'react-typist-component';
import React from "react";
import Container from "react-bootstrap/Container";
import { Jumbotron } from "./migration";

const MainBody = React.forwardRef(
  ({ gradient, title, message, icons }, ref) => {
    return (
      <Jumbotron
        fluid
        id="home"
        style={{
          background: `url('/alicestreet-bg.png') center/cover no-repeat`,
          backgroundSize: "cover",
        }}
        className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
      >
        <div id="stars"></div>
        <Container className="text-center" style={{ marginTop: '20vh' }}>
          <Typist>
            <div className="lead typist" style={{ color: '#fff', fontWeight: 'bold', fontSize: '2rem', textShadow: '4px 4px 16px #000, 0 0 8px #1e90ff' }}>
              {message}
            </div>
          </Typist>
          <div className="p-5">
            {icons.map((icon, index) => (
              <a
                key={`social-icon-${index}`}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
              >
                <i className={`fab ${icon.image}  fa-3x socialicons`} />
              </a>
            ))}
          </div>
          {/* <a
            className="btn btn-outline-light btn-lg "
            href="#aboutme"
            role="button"
            aria-label="Learn more about me"
          >
            Upcoming Gigs
          </a> */}
        </Container>
      </Jumbotron>
    );
  }
);

export default MainBody;
